<template>
  <div>
    <el-form :inline="false" label-position="top" size="small">
      <el-row
        :gutter="20" type="flex" justify="left"
        style="flex-wrap: wrap"
      >
        <el-col :span="7">
          <!--留言时间-->
          <el-form-item prop="timeType">
            <template slot="label">
              <div class="selectLabel">
                <el-select v-model="queryForm.params.timeType" :style="IsWidth">
                  <el-option key="1" :label="$t('GlobalSetObj.CreationTime')" :value="1" />
                  <el-option key="2" :label="$t('customerManagements.genterTiem')" :value="2" />
                </el-select>
              </div>
            </template>
            <el-date-picker
              v-model="timeValue"
              :clearable="false"
              :default-time="['00:00:00', '23:59:59']"
              :end-placeholder="$t('GlobalSetObj.endDate')"
              :format="$i18n.locale == 'zh' ? zhDate : ptDate"
              :start-placeholder="$t('GlobalSetObj.startDate')"
              range-separator="~"
              style="width: 100%"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!-- 客户名称  -->
          <el-form-item :label="$t('orderCenterCont.CustomerName')">
            <el-select
              v-model="queryForm.params.customerId"
              :placeholder="$t('GlobalSetObj.OnlyAreDisplayed')"
              :remote-method="searchSearchUserList"
              clearable
              filterable
              remote
              reserve-keyword
              style="width: 100%"
              @change="searchGetUserListFocus2"
              @focus="searchSearchUserListFocus1"
            >
              <el-option
                v-for="(item, index) in searchUserList"
                :key="index"
                :label="item.username"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!-- 商户  -->
          <el-form-item :label="$t('collectionCenter.CommercialOwner')">
            <el-select
              v-model="queryForm.params.merchantId"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              :remote-method="getapiCustomerPageList"
              clearable
              filterable
              remote
              reserve-keyword
              style="width: 100%"
              @change="searchgetapiCustomerPageList"
              @focus="searchgetapiCustomerPageList1"
            >
              <el-option
                v-for="(item, index) in customerMerchant"
                :key="index"
                :label="item.merchantName + '（' + item.merchantCode + '）'"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--  时效类型   -->
          <el-form-item :label="$t('customerManagements.TimeType')">
            <el-select
              v-model="queryForm.params.ageingType"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              style="width: 100%"
            >
              <el-option :label="$t('GlobalSetObj.all')" :value="null" />
              <!--  客户派送时效  -->
              <el-option :label="$t('customerManagements.CustomerDeliveryTime')" :value="0" />
              <!--  客户闭环时效  -->
              <el-option :label="$t('customerManagements.CustomerClosedLoop')" :value="1" />
              <!--  内部网点时效  -->
              <el-option :label="$t('customerManagements.internalBranchTimeliness')" :value="2" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--  配置类型   -->
          <el-form-item :label="$t('customerManagements.ConfigType')">
            <el-select
              v-model="queryForm.params.configType"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              style="width: 100%"
            >
              <el-option :label="$t('GlobalSetObj.all')" :value="null" />
              <el-option :label="$t('customerManagements.ConfigTypeCustomer')" :value="0" />
              <el-option :label="$t('customerManagements.ConfigTypeChannel')" :value="1" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!-- 客户渠道 -->
          <el-form-item :label="$t('customerManagements.customerChannel')">
            <el-select
              v-model="queryForm.params.channelCode"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              filterable
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in channelList"
                :key="index"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--  状态   -->
          <el-form-item :label="$t('GlobalSetObj.status')">
            <el-select
              v-model="queryForm.params.status"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              style="width: 100%"
            >
              <el-option :label="$t('GlobalSetObj.all')" :value="null" />
              <el-option :label="$t('GlobalSetObj.enable')" :value="1" />
              <el-option :label="$t('GlobalSetObj.stop')" :value="0" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!-- 货物类型 -->
          <el-form-item :label="$t('placeOrder.goodType')">
            <el-select
              v-model="queryForm.params.goodsType"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              style="width: 100%"
            >
              <el-option
                v-for="(label, key) in goodsTypeMap"
                :key="key"
                :label="label"
                :value="Number(key)"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$t('collectionCenter.dot')">
            <ElSelectV2
              ref="siteSelect"
              v-model="queryForm.params.siteId"
              :options="siteAllList"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              filterable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$t('customerManagements.slaId')">
            <el-input
              v-model="queryForm.params.slaId"
              :placeholder="$t('GlobalSetObj.pleaseInput')"
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="15">
          <!--搜索-->
          <el-button
            icon="el-icon-search" size="small" type="primary"
            @click="enterSearch"
          >{{ $t('newOrder.search') }}
          </el-button>
          <!--重置-->
          <el-button
            icon="el-icon-refresh-left" size="small" type="info"
            @click="resetForm()"
          >{{ $t('newOrder.reset') }}
          </el-button>
          <el-button
            size="small"
            style="margin-bottom: 15px"
            type="primary"
            @click="openExpressTime"
          >{{ $t('customerManagements.add') }}
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <!--  表格数据  -->
    <el-table
      :data="tableData"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
      border
      class="table_class"
      style="width: 100%"
    >
      <el-table-column
        :label="$t('GlobalSetObj.serial')" align="center" type="index"
        width="70"
      />
      <el-table-column
        v-for="item in tableHeaderList"
        :key="item.id"
        :label="item.label"
        :min-width="item.cloWidth"
        :prop="item.prop"
        :show-overflow-tooltip="false"
      >
        <template slot-scope="scope">
          <div
            v-if="item.prop === 'merchantName' && scope.row.merchantName && scope.row.merchantCode"
          >
            <span> {{ scope.row.merchantName }}（{{ scope.row.merchantCode }}） </span>
          </div>
          <div v-else-if="item.prop === 'siteNames'">
            <el-tooltip
              :content="scope.row.siteNames" class="item" effect="dark"
              placement="top"
            >
              <span class="site-names-text">{{ scope.row.siteNames || '- -' }}</span>
            </el-tooltip>
          </div>
          <div v-else-if="item.prop === 'statusTypeObjName'">
            <el-tag
              v-if="scope.row.status === 0" effect="dark" size="small"
              type="danger"
            >{{ scope.row.statusTypeObjName }}
            </el-tag>
            <el-tag
              v-else effect="dark" size="small"
              type=""
            >{{ scope.row.statusTypeObjName }}
            </el-tag>
          </div>
          <div v-else-if="item.prop === 'configTypeName'">
            <el-tag
              v-if="scope.row.configType === 1" effect="dark" size="small"
              type="warning"
            >{{ $t('customerManagements.ConfigTypeChannel') }}
            </el-tag>
            <el-tag v-else-if="scope.row.configType === 0" effect="dark" size="small">
              {{ $t('customerManagements.ConfigTypeCustomer') }}
            </el-tag>
            <span v-else>- -</span>
          </div>
          <div v-else-if="item.prop === 'calculatedDay'">
            <div style="line-height: 30px">
              <el-tag
                v-for="(item1, index) in scope.row.calculatedDayList1"
                :key="index"
                :type="`${scope.row.calculatedDayList[index] > 5 ? 'danger' : ''}`"
                effect="dark"
                size="small"
                style="margin-right: 5px"
              >
                {{ item1 }}
              </el-tag>
            </div>
          </div>
          <div v-else-if="item.prop === 'ageingType'">
            <!-- 0：客户派送时效  1: 客户闭环时效  2： 内部网点时效 -->
            <el-tag
              v-if="scope.row.ageingType === 0" effect="dark" size="small"
              type="primary"
            >{{ $t('customerManagements.CustomerDeliveryTime') }}
            </el-tag>
            <el-tag v-else-if="scope.row.ageingType === 1" size="small" type="primary">
              {{ $t('customerManagements.CustomerClosedLoop') }}
            </el-tag>
            <el-tag
              v-else effect="dark" size="small"
              type="success"
            >{{ $t('customerManagements.internalBranchTimeliness') }}
            </el-tag>
          </div>
          <div v-else-if="item.prop === 'customerName'">
            <span v-if="scope.row.configType === 1">{{ scope.row.channelCode || '- -' }}</span>
            <span v-else>{{ scope.row.customerName || '- -' }}</span>
          </div>
          <div v-else-if="item.prop === 'slaVersion'">
            <span>{{ scope.row.slaVersionDisplay || (scope.row.slaVersion ? 'V' + Number(scope.row.slaVersion).toFixed(1) : '- -') }}</span>
          </div>
          <div v-else>{{ scope.row[item.prop] ? `${scope.row[item.prop]}` : '- -' }}</div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('newOrder.operation')" align="center" fixed="right"
        width="180"
      >
        <template slot-scope="scope">
          <div style="display: flex; justify-content: space-between; align-items: center">
            <el-tooltip
              :content="$t('customerManagements.downloadTimeTable')"
              class="item"
              effect="dark"
              placement="top"
            >
              <i class="el-icon-download textOperator" @click="downloadOrder(scope.row)" />
            </el-tooltip>
            <el-tooltip
              :content="$t('customerManagements.viewVersionHistory')"
              class="item"
              effect="dark"
              placement="top"
            >
              <i class="el-icon-time textOperator" @click="viewVersionHistory(scope.row)" />
            </el-tooltip>
            <el-tooltip
              :content="$t('GlobalSetObj.edit')"
              class="item"
              effect="dark"
              placement="top"
            >
              <i class="el-icon-edit textOperator" @click="editMessage(scope.row)" />
            </el-tooltip>
            <el-tooltip
              v-if="scope.row.status === 1"
              v-permit:remove="'btn:configurationManagement:agingHistoryRefresh:refresh'"
              :content="$t('collectionCenter.agingHistoryRefresh')" class="item" effect="dark"
              placement="top"
            ><!--时效历史数据更新-->
              <i class="el-icon-refresh textOperator" @click="openRefreshTaskDialog(scope.row)" />
            </el-tooltip>
            <el-tooltip
              v-if="scope.row.status === 0"
              :content="$t('GlobalSetObj.enable')"
              class="item"
              effect="dark"
              placement="top"
            >
              <i class="el-icon-circle-check textOperator" @click="updateStatus(scope.row)" />
            </el-tooltip>
            <el-tooltip
              v-else
              :content="$t('GlobalSetObj.stop')"
              class="item"
              effect="dark"
              placement="top"
            >
              <i class="el-icon-remove-outline textOperator1" @click="updateStatus(scope.row)" />
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!--  分页  -->
    <el-pagination
      :current-page="queryForm.pageNumber"
      :page-size="queryForm.pageSize"
      :page-sizes="[10, 20, 50, 100]"
      :total="queryForm.total"
      background
      layout="total, sizes, prev, pager, next, jumper"
      style="margin: 10px 0; float: right"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    <!-- 新增客户视角 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="cusTimeDialogTitle"
      :visible.sync="addCusTimeDialog"
      width="550px"
      @close="handleAddCusTimeDialog"
    >
      <el-form
        v-if="expressTimeType === 2"
        :key="addCusTimeDialog"
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        class="demo-ruleForm"
        label-width="auto"
      >
        <el-form-item :label="$t('GlobalSetObj.SelectSites')" prop="siteIds">
          <ElSelectV2
            ref="siteSelect"
            v-model="ruleForm.siteIds"
            :options="siteListWithAll"
            :placeholder="$t('GlobalSetObj.pleaseChoose')"
            clearable
            collapse-tags
            filterable
            multiple
            style="width: 100%"
            @change="selectSite"
          >
            <template #default="{ item }">
              <el-checkbox
                v-if="item.value === '__ALL__'"
                v-model="isAllSelected"
                @change="checkAllChange"
                @click.native.stop
              >
                {{ $t('collectionCenter.allSelect') }}
              </el-checkbox>
            </template>
          </ElSelectV2>
        </el-form-item>
        <el-form-item :label="$t('placeOrder.goodType')" prop="goodsType">
          <el-select
            v-model="ruleForm.goodsType"
            :placeholder="$t('GlobalSetObj.pleaseChoose')"
            style="width: 100%"
          >
            <el-option
              v-for="(label, key) in goodsTypeMap"
              :key="key"
              :label="label"
              :value="Number(key)"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('customerManagements.timeCalcuDay')" prop="calculatedDay">
          <el-select
            v-model="ruleForm.calculatedDay"
            :placeholder="$t('GlobalSetObj.pleaseChoose')"
            multiple
            style="width: 100%"
          >
            <el-option :label="$t('customerManagements.weekOne')" value="1" />
            <el-option :label="$t('customerManagements.weekTwo')" value="2" />
            <el-option :label="$t('customerManagements.weekThree')" value="3" />
            <el-option :label="$t('customerManagements.weekFoure')" value="4" />
            <el-option :label="$t('customerManagements.weekFirtFive')" value="5" />
            <el-option :label="$t('customerManagements.weekSix')" value="6" />
            <el-option :label="$t('customerManagements.weekSeven')" value="7" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('customerManagements.genterTiem')" prop="effectiveTime">
          <el-date-picker
            v-model="ruleForm.effectiveTime"
            :default-time="defaultTime"
            :picker-options="pickerOptions"
            :placeholder="$t('newOrder.SelectDatetime')"
            style="width: 100%"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
          />
        </el-form-item>
        <el-form-item :label="$t('customerManagements.agingType')" prop="agingType">
          <el-select v-model="ruleForm.agingType" style="width: 100%">
            <el-option :label="$t('customerManagements.anDay')" :value="0" />
            <el-option :label="$t('customerManagements.anTime')" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('customerManagements.timeframeStartingPointName')"
          prop="timeframeStartingPoint"
        >
          <el-select
            v-model="ruleForm.timeframeStartingPoint"
            :placeholder="$t('GlobalSetObj.pleaseChoose')"
            style="width: 100%"
          >
            <el-option :label="$t('newOrder.StorageTimeOutlets')" value="dispatch_receipt_time" />
          </el-select>
        </el-form-item>
        <el-form-item prop="">
          <template slot="label">
            <el-button size="small" type="primary" @click="triggerFileInput">{{ $t('customerManagements.clickUpload') }}
            </el-button>
          </template>
          <input
            ref="referenceUpload"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            style="display: none"
            type="file"
            @change="uploadFile($event)"
          >
          <div class="">
            <span class="downModule" @click="downLoadFile">{{
              $t('orderCenterCont.DownloadTemplate')
            }}</span>
            <span style="font-size: 12px; color: red">{{
              $t('customerManagements.pleaseUploadLI')
            }}</span>
          </div>
        </el-form-item>
        <div v-if="fileName" class="downLink">
          <div>{{ fileName }}</div>
          <div>
            <i class="el-icon-error" @click="delFile" />
          </div>
        </div>
      </el-form>
      <el-form
        v-else
        :key="addCusTimeDialog"
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        class="demo-ruleForm"
        label-width="auto"
      >
        <el-form-item :label="$t('customerManagements.ConfigType')" prop="configType">
          <el-radio-group v-model="ruleForm.configType" :disabled="!!editId" @change="handleConfigTypeChange">
            <el-radio :label="0">{{ $t('customerManagements.ConfigTypeCustomer') }}</el-radio>
            <el-radio :label="1">{{ $t('customerManagements.ConfigTypeChannel') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.configType !== 1"
          :label="$t('customerManagements.selectCus')"
          prop="customerId"
        >
          <el-select
            v-model="ruleForm.customerId"
            :disabled="!!editId"
            :placeholder="$t('GlobalSetObj.pleaseChoose')"
            :remote-method="searchFormUserList"
            clearable
            filterable
            remote
            style="width: 100%"
            @change="searchGetUserListFocus"
            @focus="searchFormUserListFocus"
          >
            <!-- 123 -->
            <el-option
              v-for="(item, index) in formUserList"
              :key="index"
              :label="item.username"
              :value="item.id + '~' + item.username"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.configType !== 1 && isSelect"
          :label="$t('collectionCenter.CommercialOwner')"
          prop="merchantId"
        >
          <div style="overflow: hidden">
            <el-select
              v-model="ruleForm.merchantId"
              :disabled="!!editId"
              :placeholder="$t('GlobalSetObj.OnlyAreDisplayed')"
              :remote-method="serchMerchantIdList"
              clearable
              filterable
              remote
              reserve-keyword
              style="width: 100%"
              @change="serchMerchantIdList1"
              @focus="serchMerchantIdList2"
            >
              <el-option
                v-for="(item, index) in merchantIdList"
                :key="index"
                :label="item.merchantName + '（' + item.merchantCode + '）'"
                :value="item.id"
              />
            </el-select>
          </div>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.configType === 1"
          :label="$t('customerManagements.customerChannel')"
          prop="channelCode"
        >
          <el-select
            v-model="ruleForm.channelCode"
            :disabled="!!editId"
            :placeholder="$t('GlobalSetObj.pleaseChoose')"
            style="width: 100%"
          >
            <el-option
              v-for="(item, index) in channelList"
              :key="index"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
        <!--        &lt;!&ndash;  时效类型   &ndash;&gt;-->
        <!--        <el-form-item :label="$t('customerManagements.TimeType')" prop="ageingType">-->
        <!--          <el-select-->
        <!--            v-model="ruleForm.ageingType"-->
        <!--            :placeholder="$t('GlobalSetObj.pleaseChoose')"-->
        <!--            style="width: 100%"-->
        <!--          >-->
        <!--            &lt;!&ndash;  客户派送时效  &ndash;&gt;-->
        <!--            <el-option :label="$t('customerManagements.CustomerDeliveryTime')" :value="0" />-->
        <!--            &lt;!&ndash;  客户闭环时效  &ndash;&gt;-->
        <!--            <el-option :label="$t('customerManagements.CustomerClosedLoop')" :value="1" />-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
        <el-form-item :label="$t('placeOrder.goodType')" prop="goodsType">
          <el-select
            v-model="ruleForm.goodsType"
            :placeholder="$t('GlobalSetObj.pleaseChoose')"
            style="width: 100%"
          >
            <el-option
              v-for="(label, key) in goodsTypeMap"
              :key="key"
              :label="label"
              :value="Number(key)"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('customerManagements.timeCalcuDay')" prop="calculatedDay">
          <el-select
            v-model="ruleForm.calculatedDay"
            :placeholder="$t('GlobalSetObj.pleaseChoose')"
            multiple
            style="width: 100%"
          >
            <el-option :label="$t('customerManagements.weekOne')" value="1" />
            <el-option :label="$t('customerManagements.weekTwo')" value="2" />
            <el-option :label="$t('customerManagements.weekThree')" value="3" />
            <el-option :label="$t('customerManagements.weekFoure')" value="4" />
            <el-option :label="$t('customerManagements.weekFirtFive')" value="5" />
            <el-option :label="$t('customerManagements.weekSix')" value="6" />
            <el-option :label="$t('customerManagements.weekSeven')" value="7" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('customerManagements.genterTiem')" prop="effectiveTime">
          <el-date-picker
            v-model="ruleForm.effectiveTime"
            :default-time="defaultTime"
            :picker-options="pickerOptions"
            :placeholder="$t('newOrder.SelectDatetime')"
            style="width: 100%"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
          />
        </el-form-item>
        <el-form-item :label="$t('customerManagements.agingType')" prop="agingType">
          <el-select v-model="ruleForm.agingType" style="width: 100%">
            <el-option :label="$t('customerManagements.anDay')" :value="0" />
            <el-option :label="$t('customerManagements.anTime')" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('customerManagements.timeframeStartingPointName')"
          prop="timeframeStartingPoint"
        >
          <el-select
            v-model="ruleForm.timeframeStartingPoint"
            :placeholder="$t('GlobalSetObj.pleaseChoose')"
            style="width: 100%"
          >
            <el-option
              v-for="item in startLabel"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="">
          <template slot="label">
            <el-button size="small" type="primary" @click="triggerFileInput">{{ $t('customerManagements.clickUpload') }}
            </el-button>
          </template>
          <input
            ref="referenceUpload"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            style="display: none"
            type="file"
            @change="uploadFile($event)"
          >
          <div class="">
            <span class="downModule" @click="downLoadFile">{{
              $t('orderCenterCont.DownloadTemplate')
            }}</span>
            <span style="font-size: 12px; color: red">{{
              $t('customerManagements.pleaseUploadLI')
            }}</span>
          </div>
        </el-form-item>
        <div v-if="fileName" class="downLink">
          <div>{{ fileName }}</div>
          <div>
            <i class="el-icon-error" @click="delFile" />
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cusSubmit(1)">{{ $t('GlobalSetObj.cancel') }}</el-button>
        <el-button size="small" type="primary" @click="cusSubmit(2)">{{ $t('GlobalSetObj.confirm') }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 新增快递时效 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="expressTimeTitle"
      :visible.sync="expressTimeDialog"
      width="450px"
      @close="handleExpressTimeDialog"
    >
      <div class="expressTime_class">
        <!-- 客户派送时效 -->
        <el-button
          plain size="medium" type="primary"
          @click="handleExpressTime(0)"
        >{{ $t('customerManagements.CustomerDeliveryTime') }}
        </el-button>
        <br>
        <!-- 客户闭环时效 -->
        <el-button
          plain size="medium" type="primary"
          @click="handleExpressTime(1)"
        >{{ $t('customerManagements.CustomerClosedLoop') }}
        </el-button>
        <br>
        <!-- 内部网点时效 -->
        <el-button
          plain size="medium" type="primary"
          @click="handleExpressTime(2)"
        >{{ $t('customerManagements.internalBranchTimeliness') }}
        </el-button>
        <br>
      </div>
    </el-dialog>

    <!-- 新增时效历史数据更新任务弹窗 -->
    <el-dialog
      title="时效历史数据更新"
      :visible.sync="refreshTaskDialog"
      width="500px"
      :close-on-click-modal="false"
      @close="closeRefreshTaskDialog"
    >
      <el-form
        ref="refreshFormRef"
        :model="refreshForm"
        :rules="refreshFormRules"
        label-width="120px"
        size="small"
      >
        <el-form-item label="时效类型：">
          <span>{{
            refreshForm.agingType === 0
              ? $t('customerManagements.CustomerDeliveryTime')
              : $t('customerManagements.CustomerClosedLoop')
          }}</span>
        </el-form-item>
        <el-form-item label="客户/渠道：">
          <span>{{ refreshForm.customerName || refreshForm.channelCode || '- -' }}</span>
        </el-form-item>
        <el-form-item label="时效ID：">
          <span>{{ refreshForm.slaId }}</span>
        </el-form-item>
        <el-form-item label="使用的时效版本：">
          <span>V{{ refreshForm.slaVersion }}</span>
        </el-form-item>
        <el-form-item label="刷新时间范围：" prop="refreshStartTime">
          <el-date-picker
            v-model="refreshForm.refreshStartTime"
            type="datetime"
            placeholder="开始时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 48%"
          />
          <span style="display: inline-block; width: 4%; text-align: center">至</span>
          <el-date-picker
            v-model="refreshForm.refreshEndTime"
            type="datetime"
            placeholder="结束时间(默认当前)"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 48%"
          />
          <div style="font-size: 12px; color: #909399; margin-top: 5px; line-height: 1.5">
            提示：选择的时间为刷新的开始时间和截止时间，如果不选择结束时间，默认截止到当前最新时间。
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="refreshTaskDialog = false">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="refreshSubmitting"
          @click="submitRefreshTask"
        >确定</el-button>
      </div>
    </el-dialog>

    <!-- 版本历史弹窗 -->
    <el-dialog
      :title="$t('customerManagements.versionHistory')"
      :visible.sync="versionHistoryDialog"
      width="90%"
      @close="closeVersionHistoryDialog"
    >
      <el-table :data="versionHistoryData" border max-height="500">
        <el-table-column
          :label="$t('GlobalSetObj.serial')"
          align="center"
          type="index"
          width="60"
        />
        <el-table-column
          prop="slaVersionDisplay"
          :label="$t('customerManagements.slaVersion')"
          min-width="100"
        />
        <el-table-column
          prop="createTime"
          :label="$t('customerManagements.snapshotTime')"
          min-width="160"
        />
        <el-table-column
          v-for="item in historyTableHeaderList"
          :key="item.id"
          :label="item.label"
          :min-width="item.cloWidth"
          :prop="item.prop"
          :show-overflow-tooltip="false"
        >
          <template slot-scope="scope">
            <div
              v-if="
                item.prop === 'merchantName' && scope.row.merchantName && scope.row.merchantCode
              "
            >
              <span> {{ scope.row.merchantName }}（{{ scope.row.merchantCode }}） </span>
            </div>
            <div v-else-if="item.prop === 'siteNames'">
              <el-tooltip
                :content="scope.row.siteNames" class="item" effect="dark"
                placement="top"
              >
                <span class="site-names-text">{{ scope.row.siteNames || '- -' }}</span>
              </el-tooltip>
            </div>
            <div v-else-if="item.prop === 'statusTypeObjName'">
              <el-tag
                v-if="scope.row.status === 0" effect="dark" size="small"
                type="danger"
              >{{ scope.row.statusTypeObjName }}
              </el-tag>
              <el-tag
                v-else effect="dark" size="small"
                type=""
              >{{ scope.row.statusTypeObjName }}
              </el-tag>
            </div>
            <div v-else-if="item.prop === 'configTypeName'">
              <el-tag
                v-if="scope.row.configType === 1" effect="dark" size="small"
                type="warning"
              >{{ $t('customerManagements.ConfigTypeChannel') }}
              </el-tag>
              <el-tag v-else-if="scope.row.configType === 0" effect="dark" size="small">
                {{ $t('customerManagements.ConfigTypeCustomer') }}
              </el-tag>
              <span v-else>- -</span>
            </div>
            <div v-else-if="item.prop === 'calculatedDay'">
              <div style="line-height: 30px">
                <el-tag
                  v-for="(item1, index) in scope.row.calculatedDayList1"
                  :key="index"
                  :type="`${scope.row.calculatedDayList[index] > 5 ? 'danger' : ''}`"
                  effect="dark"
                  size="small"
                  style="margin-right: 5px"
                >
                  {{ item1 }}
                </el-tag>
              </div>
            </div>
            <div v-else-if="item.prop === 'ageingType'">
              <!-- 0：客户派送时效  1: 客户闭环时效  2： 内部网点时效 -->
              <el-tag
                v-if="scope.row.ageingType === 0" effect="dark" size="small"
                type="primary"
              >{{ $t('customerManagements.CustomerDeliveryTime') }}
              </el-tag>
              <el-tag v-else-if="scope.row.ageingType === 1" size="small" type="primary">
                {{ $t('customerManagements.CustomerClosedLoop') }}
              </el-tag>
              <el-tag
                v-else effect="dark" size="small"
                type="success"
              >{{ $t('customerManagements.internalBranchTimeliness') }}
              </el-tag>
            </div>
            <div v-else-if="item.prop === 'customerName'">
              <span v-if="scope.row.configType === 1">{{ scope.row.channelCode || '- -' }}</span>
              <span v-else>{{ scope.row.customerName || '- -' }}</span>
            </div>
            <div v-else>{{ scope.row[item.prop] ? `${scope.row[item.prop]}` : '- -' }}</div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('newOrder.operation')" width="100" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="downloadVersionArea(scope.row)">
              {{ $t('customerManagements.downloadTimeTable') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  apiCustomerPage,
  apiCustomerPageList,
  getCustomerTimeList,
  getMerchantByCustomerId,
  getMerchantByCustomerIdSearch,
  localAgingAdd,
  localAgingdownload,
  localAgingdownloadmodule,
  localAgingEdit,
  localAgingGetConfigPage,
  localAgingupdateStatus,
  getVersionHistoryLocalAging,
  downloadVersionAreaLocalAging,
  createAgingRefreshTask
} from '@/api/customer';
import dayjs from 'dayjs';
import { saveAs } from 'file-saver';
import ElSelectV2 from 'el-select-v2';
import { searchSitequeryAllSite } from '@/api/lanshou';
import { getSiteBySiteType } from '@/api/regionConfig';
import { cloneDeep } from 'lodash-es';
import { EventBus } from '@/utils/bus';

export default {
  name: 'TimeToCustomer',
  components: {
    ElSelectV2
  },
  data() {
    return {
      siteAllList: [], // 查询：网点数据
      isAllSelected: false, // 网点全选
      siteList: [],
      expressTimeType: null,
      expressTimeDialog: false,
      expressTimeTitle: '',
      // 是否格式化成巴西时间
      isTormat: false,
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      timeValue: [],
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        total: 0,
        params: {
          timeType: 1, // 留言时间
          customerId: '', // 客户ID
          startTime: '', // 开始时间
          endTime: '', // 结束时间
          status: null, // 状态
          merchantId: '', // 商户Id
          ageingType: null, // 时效类型
          configType: null, // 配置类型
          channelCode: '', // 渠道
          siteId: '',
          goodsType: null, // 货物类型
          slaId: null
        }
      },
      tableData: [],
      versionHistoryDialog: false,
      versionHistoryData: [],
      refreshTaskDialog: false,
      refreshSubmitting: false,
      refreshForm: {
        configId: '',
        agingType: '',
        slaId: '',
        slaVersion: '',
        customerId: '',
        customerName: '',
        channelCode: '',
        refreshStartTime: '',
        refreshEndTime: ''
      },
      refreshFormRules: {
        refreshStartTime: [{ required: true, message: '请选择刷新范围起点', trigger: 'change' }]
      },
      tableHeaderList: [
        // 创建时间
        { id: 1, label: this.$t('GlobalSetObj.CreationTime'), prop: 'createTime', cloWidth: '160' },
        // 时效类型
        {
          id: 2,
          label: this.$t('customerManagements.TimeType'),
          prop: 'ageingType',
          cloWidth: '150'
        },
        // 客户或渠道名称
        {
          id: 3,
          label: this.$t('customerManagements.CustomerOrChannelName'),
          prop: 'customerName',
          cloWidth: '150'
        },
        // 配置类型
        {
          id: 4,
          label: this.$t('customerManagements.ConfigType'),
          prop: 'configTypeName',
          cloWidth: '150'
        },
        // 商户
        {
          id: 5,
          label: this.$t('collectionCenter.CommercialOwner'),
          prop: 'merchantName',
          cloWidth: '150'
        },
        // 货物类型
        {
          id: 51,
          label: this.$t('placeOrder.goodType'),
          prop: 'goodsTypeName',
          cloWidth: '100'
        },
        // 网点
        {
          id: 6,
          label: this.$t('collectionCenter.dot'),
          prop: 'siteNames',
          cloWidth: '150'
        },
        // 生效时间
        {
          id: 7,
          label: this.$t('customerManagements.genterTiem'),
          prop: 'effectiveTime',
          cloWidth: '150'
        },
        // 时效模式
        {
          id: 8,
          label: this.$t('customerManagements.agingType'),
          prop: 'agingTypeName',
          cloWidth: '150'
        },
        // 状态
        {
          id: 9,
          label: this.$t('GlobalSetObj.status'),
          prop: 'statusTypeObjName',
          cloWidth: '100'
        },
        { id: 15, label: this.$t('customerManagements.slaId'), prop: 'slaId', cloWidth: '160' },
        {
          id: 16,
          label: this.$t('customerManagements.slaVersion'),
          prop: 'slaVersion',
          cloWidth: '100'
        },
        // 时效计算天数
        {
          id: 10,
          label: this.$t('customerManagements.timeCalcuDay'),
          prop: 'calculatedDay',
          cloWidth: '310'
        },
        // 时效起点
        {
          id: 11,
          label: this.$t('customerManagements.timeframeStartingPointName'),
          prop: 'timeframeStartingPointName',
          cloWidth: '150'
        },
        // 创建人
        {
          id: 12,
          label: this.$t('GlobalSetObj.CreatePeople'),
          prop: 'creatorName',
          cloWidth: '150'
        },
        // 最新操作人
        {
          id: 13,
          label: this.$t('customerManagements.newOptioner'),
          prop: 'updaterName',
          cloWidth: '150'
        },
        // 最新操作时间
        {
          id: 14,
          label: this.$t('customerManagements.newOptionTime'),
          prop: 'updateTime',
          cloWidth: '160'
        }
      ],
      searchUserList: [], // 顶端搜索使用的用户列表
      formUserList: [], // 弹窗表单使用的用户列表
      customerMerchant: [],
      addCusTimeDialog: false,
      cusTimeDialogTitle: this.$t('customerManagements.newCusTime'),
      ruleForm: {
        customerId: '',
        ageingType: null,
        calculatedDay: [],
        effectiveTime: '',
        timeframeStartingPoint: '',
        agingType: 0,
        merchantId: '',
        configType: 0, // 默认按客户
        channelCode: '',
        goodsType: 0, // 货物类型：默认全部
        siteIds: []
      },
      channelList: [], // 渠道列表字典
      rules: {
        siteIds: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'change' }
        ],
        customerId: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'change' }
        ],
        channelCode: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'change' }
        ],
        calculatedDay: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'change' }
        ],
        effectiveTime: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'change' }
        ],
        timeframeStartingPoint: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'change' }
        ],
        agingType: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'change' }
        ],
        goodsType: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'change' }
        ]
      },
      detailData: [],
      fileName: '',
      fileData: null,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; // 一天的毫秒数
        }
      },
      defaultTime: '',
      weekList: [
        'lkjl',
        this.$t('customerManagements.weekOne'),
        this.$t('customerManagements.weekTwo'),
        this.$t('customerManagements.weekThree'),
        this.$t('customerManagements.weekFoure'),
        this.$t('customerManagements.weekFirtFive'),
        this.$t('customerManagements.weekSix'),
        this.$t('customerManagements.weekSeven')
      ],
      startLabel: [],
      startLabelCopy: [],
      editId: null,
      merchantIdList: [],
      sizeFile: '',
      isSelect: false
    };
  },
  computed: {
    historyTableHeaderList() {
      return this.tableHeaderList.filter(
        (item) => !['createTime', 'slaVersion'].includes(item.prop)
      );
    },
    goodsTypeMap() {
      return {
        0: this.$t('GlobalSetObj.all'),
        1: this.$t('placeOrder.big01'),
        2: this.$t('customerManagements.normal')
      };
    },
    IsWidth() {
      return {
        width: this.isTormat ? '180px' : '110px'
      };
    },
    siteListWithAll() {
      const allOption = {
        value: '__ALL__',
        label: this.$t('collectionCenter.allSelect')
      };
      if (this.siteList <= 0) {
        return [];
      } else {
        return [allOption, ...this.siteList];
      }
    }
  },
  created() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.getWaybillTimeRecordField();
    // this.getTimer();
    this.searchSearchUserList();
    this.searchFormUserList();
    this.searchgetapiCustomerPageList('');
    this.getapiCustomerPageList('');
    this.getChannelDicts();
    this.getAllSiteIdList();
  },
  methods: {
    // 获取时效列表
    async getWaybillTimeRecordField() {
      const res = await getCustomerTimeList('waybill_time_record_field');
      if (res.data) {
        this.startLabel = res.data;
        this.startLabelCopy = cloneDeep(res.data);
        this.getSearch();
      }
    },
    // 查询条件：获取所有网点
    getAllSiteIdList() {
      searchSitequeryAllSite().then((res) => {
        if (res.code === 200) {
          this.siteAllList = (res.data || []).map((item) => {
            return {
              value: item.id,
              label: item.name
            };
          });
        }
      });
    },
    handleExpressTimeDialog() {
      this.expressTimeDialog = false;
    },
    openExpressTime() {
      this.expressTimeDialog = true;
      this.expressTimeTitle = this.$t('customerManagements.addExpressTimeliness');
      this.merchantIdList = [];
      this.editId = null;
    },
    handleExpressTime(type) {
      if (type === 0) {
        this.startLabel = this.startLabelCopy.slice(0, -2);
      } else if (type === 1) {
        this.startLabel = this.startLabelCopy.slice(0, -1);
      } else {
        // 内部网点时效：只保留最后一个
        this.startLabel = this.startLabelCopy.slice(-1);
      }
      if (type === 2) this.ruleForm.timeframeStartingPoint = 'dispatch_receipt_time';
      this.expressTimeType = type;
      this.ruleForm.ageingType = type;
      const addTitleMap = {
        0: this.$t('customerManagements.addCustomerDeliveryTimeliness'),
        1: this.$t('customerManagements.addCustomerCycleTimeliness'),
        2: this.$t('customerManagements.addInternalBranchTimeliness')
      };
      const editTitleMap = {
        0: this.$t('customerManagements.editCustomerDeliveryTimeliness'),
        1: this.$t('customerManagements.editCustomerCycleTimeliness'),
        2: this.$t('customerManagements.editInternalBranchTimeliness')
      };
      this.cusTimeDialogTitle = this.editId ? editTitleMap[type] || '' : addTitleMap[type] || '';
      // 1 内部网点时效
      this.addCusTimeDialog = true;
      if (type !== 2) {
        this.searchFormUserList('');
      } else {
        this.getAllSite();
      }
    },
    getAllSite() {
      const form = {
        siteType: 2
      };
      getSiteBySiteType(form).then((res) => {
        if (res.code === 200) {
          this.siteList = (res.data || []).map((item) => {
            return {
              value: item.id,
              label: item.name
            };
          });
        }
      });
    },
    checkAllChange(val) {
      if (val) {
        this.ruleForm.siteIds = this.siteList.map((item) => item.value);
        this.isAllSelected = true;
      } else {
        this.ruleForm.siteIds = [];
        this.isAllSelected = false;
      }
    },
    selectSite(value) {
      const allValue = '__ALL__';
      const actualValues = this.siteList.map((item) => item.value);
      if (value.includes(allValue)) {
        if (!this.isAllSelected) {
          this.ruleForm.siteIds = [...actualValues];
          this.isAllSelected = true;
        } else {
          this.ruleForm.siteIds = [];
          this.isAllSelected = false;
        }
      } else {
        this.isAllSelected =
          value.length === actualValues.length && actualValues.every((v) => value.includes(v));
      }
    },

    async getChannelDicts() {
      const res = await getCustomerTimeList('customer_channel');
      this.channelList = res.data || [];
    },
    handleConfigTypeChange(val) {
      if (val === 1) {
        this.ruleForm.customerId = '';
        this.ruleForm.merchantId = '';
        this.isSelect = false;
        this.$refs.ruleForm.clearValidate(['customerId', 'merchantId']);

        // 当渠道列表只有一个时，默认选中
        if (this.channelList && this.channelList.length === 1 && !this.ruleForm.channelCode) {
          this.ruleForm.channelCode = this.channelList[0].key;
        }
      } else {
        this.ruleForm.channelCode = '';
        this.$refs.ruleForm.clearValidate(['channelCode']);
      }
    },
    triggerFileInput() {
      this.$refs.referenceUpload.click();
    },
    // 上传文件
    uploadFile(e) {
      console.log(e, 'LKLK');
      this.fileData = e.target.files[0];
      this.fileName = e.target.files[0].name;
      this.sizeFile = e.target.files[0].size;
      // const formData = new FormData();
      // formData.append('customerId', 'value1');
      // formData.append('key2', 'value2');
      // // 如果有文件上传
      // formData.append('file', this.fileData, this.fileName);
    },
    // 点击确定
    cusSubmit(val) {
      if (val === 1) {
        this.addCusTimeDialog = false;
        this.isSelect = false;
      } else {
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            const formData = new FormData();
            const arr = this.ruleForm.customerId.split('~');
            if (this.ruleForm.configType === 1) {
              formData.append('configType', 1);
              formData.append('channelCode', this.ruleForm.channelCode);
            } else {
              formData.append('configType', 0);
              formData.append('customerId', arr[0]);
              formData.append('customerName', arr[1]);
              if (this.ruleForm.merchantId) {
                formData.append('merchantId', this.ruleForm.merchantId);
              }
            }
            formData.append('effectiveTime', this.ruleForm.effectiveTime);
            formData.append('timeframeStartingPoint', this.ruleForm.timeframeStartingPoint);
            formData.append('agingType', this.ruleForm.agingType);
            formData.append('ageingType', this.ruleForm.ageingType);
            if (this.ruleForm.goodsType !== undefined && this.ruleForm.goodsType !== null) {
              formData.append('goodsType', this.ruleForm.goodsType);
            }
            const calculatedDay = this.ruleForm.calculatedDay.join(',');
            formData.append('calculatedDay', calculatedDay);
            if (this.expressTimeType === 2) {
              formData.append('siteIds', this.ruleForm.siteIds);
            }
            // 如果有文件上传
            if (this.fileName) {
              formData.append('sizeFile', this.sizeFile);
              if (this.editId) {
                if (this.fileData) {
                  formData.append('file', this.fileData, this.fileName);
                }
                console.log(this.fileData, 'this.fileData');
                formData.append('fileName', this.fileName);
              } else {
                formData.append('file', this.fileData, this.fileName);
                formData.append('fileName', this.fileName);
              }
            } else {
              this.$message.error(this.$t('customerManagements.pleaseUploadFile'));
              return;
            }
            const addTitleMap = {
              0: this.$t('customerManagements.addCustomerDeliveryTimeliness'),
              1: this.$t('customerManagements.addCustomerCycleTimeliness'),
              2: this.$t('customerManagements.addInternalBranchTimeliness')
            };
            if (Object.values(addTitleMap).includes(this.cusTimeDialogTitle)) {
              localAgingAdd(formData).then((res) => {
                if (res.code === 200) {
                  this.addCusTimeDialog = false;
                  this.expressTimeDialog = false;
                  this.isSelect = false;
                  this.$message.success(this.$t('GlobalSetObj.SaveSuccessfully'));
                  this.getSearch();
                }
              });
            } else {
              formData.append('id', this.editId);
              localAgingEdit(formData).then((res) => {
                if (res.code === 200) {
                  this.addCusTimeDialog = false;
                  this.expressTimeDialog = false;
                  this.isSelect = false;
                  this.$message.success(this.$t('GlobalSetObj.SaveSuccessfully'));
                  this.getSearch();
                }
              });
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    },
    downLoadFile() {
      localAgingdownloadmodule(this.expressTimeType).then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'table_data.xlsx'); // 更改为实际的文件名和扩展名
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url); // 清理 URL
      });
    },
    // 删除文件
    delFile() {
      this.fileName = '';
      this.fileData = null;
      this.sizeFile = '';
    },
    // 编辑
    editMessage(row) {
      const _this = this;
      const editTitleMap = {
        0: this.$t('customerManagements.editCustomerDeliveryTimeliness'),
        1: this.$t('customerManagements.editCustomerCycleTimeliness'),
        2: this.$t('customerManagements.editInternalBranchTimeliness')
      };
      this.cusTimeDialogTitle = editTitleMap[row.ageingType];
      this.editId = row.id;
      this.expressTimeType = row.ageingType;
      if (row.ageingType === 0) {
        this.startLabel = this.startLabelCopy.slice(0, -2);
      } else if (row.ageingType === 1) {
        this.startLabel = this.startLabelCopy.slice(0, -1);
      } else {
        // 内部网点时效：只保留最后一个
        this.startLabel = this.startLabelCopy.slice(-1);
      }
      const populateForm = () => {
        _this.addCusTimeDialog = true;
        _this.ruleForm.timeframeStartingPoint = row.timeframeStartingPoint;
        _this.ruleForm.calculatedDay = row.calculatedDayList;
        _this.ruleForm.effectiveTime = row.effectiveTime;
        _this.ruleForm.customerId = row.customerId ? row.customerId + '~' + row.customerName : '';
        _this.ruleForm.agingType = row.agingType;
        _this.ruleForm.merchantId = row.merchantId;
        _this.ruleForm.configType = row.configType || 0;
        _this.ruleForm.channelCode = row.channelCode;
        _this.ruleForm.goodsType = row.goodsType;
        _this.fileName = row.fileName;
        _this.ruleForm.siteIds = row.siteIds;
        _this.ruleForm.ageingType = row.ageingType;
      };

      if (row.configType === 1) {
        this.$nextTick(() => {
          populateForm();
        });
        return;
      }
      if (row.ageingType === 2) {
        this.$nextTick(() => {
          this.getAllSite();
          populateForm();
        });
        return;
      }

      const data = {
        pageNumber: 1, // 页数
        pageSize: 10, // 每页 行数
        params: {
          quickSearch: row.customerName
        }
      };
      apiCustomerPage(data).then((res) => {
        if (res.code === 200) {
          this.formUserList = res.data.records;
          console.log(row, 'editMessage');
          getMerchantByCustomerIdSearch(row.customerId, row.merchantName).then((res) => {
            if (res.code === 200) {
              _this.merchantIdList = res.data;
              this.isSelect = _this.merchantIdList.length > 0;
              _this.$nextTick(() => {
                populateForm();
              });
            }
          });
        }
      });
    },
    // 下载
    downloadOrder(row) {
      localAgingdownload(row.id).then((res) => {
        const saveName = row.fileName || 'table_data.xlsx';
        saveAs(res.data, saveName);
      });
    },
    // 启用停用
    updateStatus(row) {
      const data = {
        id: row.id,
        status: row.status === 1 ? 0 : 1,
        ageingType: row.ageingType
      };
      this.$confirm(this.$t('customerManagements.areSureStop'), this.$t('collectionCenter.tips'), {
        confirmButtonText: this.$t('collectionCenter.confirm'), // '确定'
        cancelButtonText: this.$t('collectionCenter.cancel'), // '取消'
        type: 'warning'
      })
        .then(async() => {
          localAgingupdateStatus(data).then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('GlobalSetObj.ModificationSuccessful'));
              this.getSearch();
            }
          });
        })
        .catch(() => {
          console.log('取消关闭');
        });
    },
    // 获取最近一周时间
    getTimer() {
      // 获取当前时间
      const now = dayjs();
      const today = dayjs().format('YYYY-MM-DD');
      const oneWeekAgo = dayjs().subtract(1, 'months').format('YYYY-MM-DD');
      this.timeValue = [oneWeekAgo + ' 00:00:00', today + ' 23:59:59'];
      this.defaultTime = now.format('HH:mm:ss');
    },
    enterSearch() {
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    // 重置
    resetForm() {
      this.queryForm.pageNumber = 1;
      this.timeValue = [];
      // this.getTimer();
      this.queryForm.params = {
        timeType: 1,
        status: null, // 状态：1、启用，2、停用
        customerId: '', // 客户id
        merchantId: '',
        ageingType: null, // 时效类型：0、客户派送时效；1、客户闭环时效
        configType: null, // 配置类型：0、按客户；1、按渠道
        channelCode: '', // 渠道
        siteId: '',
        slaId: null
      };
      this.getSearch();
      this.searchgetapiCustomerPageList('');
      this.getapiCustomerPageList('');
    },
    // 查询
    getSearch() {
      const obj = this.arrayToObject(this.startLabelCopy);
      console.log(obj, 'objobj');
      const statusTypeObj = {
        1: this.$t('GlobalSetObj.enable'),
        0: this.$t('GlobalSetObj.stop')
      };
      const timeTypeObj = {
        1: this.$t('customerManagements.anTime'),
        0: this.$t('customerManagements.anDay')
      };
      const data = {
        params: {}
      };
      data.pageSize = this.queryForm.pageSize;
      data.pageNumber = this.queryForm.pageNumber;
      data.params = this.queryForm.params;
      if (this.timeValue && this.timeValue.length > 0) {
        data.params.beginTime = this.timeValue[0];
        data.params.endTime = this.timeValue[1];
      } else {
        data.params.beginTime = null;
        data.params.endTime = null;
      }
      localAgingGetConfigPage(data).then((res) => {
        if (res.code === 200) {
          this.queryForm.total = res.data.total;
          this.tableData = res.data.records;
          this.tableData.forEach((item) => {
            item.siteNames = item.siteNames.join('，');
            item.statusTypeObjName = statusTypeObj[item.status];
            item.agingTypeName = timeTypeObj[item.agingType];
            item.goodsTypeName = this.goodsTypeMap[item.goodsType] || this.$t('GlobalSetObj.all');
            item.calculatedDayList = item.calculatedDay.split(',');
            item.calculatedDayList.sort();
            item.calculatedDayList1 = item.calculatedDayList.map((item) => {
              return this.weekList[item];
            });
            if (item.timeframeStartingPoint) {
              item.timeframeStartingPointName = obj[item.timeframeStartingPoint];
            }
          });
        }
      });
    },
    arrayToObject(arr) {
      return arr.reduce((obj, item) => {
        obj[item.key] = item.value;
        return obj;
      }, {});
    },
    // 点击分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    },
    handleAddCusTimeDialog() {
      this.fileName = '';
      this.fileData = null;
      this.ruleForm = {
        customerId: '',
        calculatedDay: [],
        effectiveTime: '',
        timeframeStartingPoint: '',
        agingType: 0,
        merchantId: '',
        configType: 0,
        channelCode: '',
        goodsType: 0,
        siteIds: []
      };
      this.isAllSelected = false;
      this.expressTimeType = null;
      this.expressTimeDialog = false;
      this.$refs.referenceUpload.value = '';
      this.isSelect = false;
      this.$refs.ruleForm.resetFields();
    },
    // 滚动到底部
    scrollToBottom() {
      this.$nextTick(() => {
        this.$refs.messageListRef.scrollTo({
          top: this.$refs.messageListRef.scrollHeight,
          behavior: 'smooth'
        });
      });
    },
    // 配合选择客户搜索商户
    serchMerchantIdList(val = '') {
      const arr = this.ruleForm.customerId.split('~');
      getMerchantByCustomerIdSearch(arr[0], val).then((res) => {
        if (res.code === 200) {
          this.merchantIdList = res.data;
          this.isSelect = true;
        }
      });
    },
    serchMerchantIdList1(val) {
      if (!val) {
        this.serchMerchantIdList('');
      }
      if (this.formUserList.length === 0) {
        // 已从 userList 改为 formUserList
        this.serchMerchantIdList('');
      }
    },
    serchMerchantIdList2() {
      console.log('searchgetapiCustomerPageList1');
      if (this.merchantIdList.length === 0) {
        this.serchMerchantIdList('');
      }
    },
    // 在新建/编辑对话框中查询用户
    searchFormUserList(val = '') {
      const data = {
        pageNumber: 1, // 页码
        pageSize: 10, // 每页行数
        params: {
          quickSearch: val
        }
      };
      apiCustomerPage(data).then((res) => {
        if (res.code === 200) {
          this.formUserList = res.data.records;
        }
      });
    },
    // 在搜索栏中查询用户
    searchSearchUserList(val = '') {
      const data = {
        pageNumber: 1, // 页码
        pageSize: 10, // 每页行数
        params: {
          quickSearch: val
        }
      };
      apiCustomerPage(data).then((res) => {
        if (res.code === 200) {
          this.searchUserList = res.data.records;
        }
      });
    },
    searchgetapiCustomerPageList(val) {
      if (!val) {
        this.getapiCustomerPageList('');
      }
      if (this.searchUserList.length === 0) {
        this.getapiCustomerPageList('');
      }
    },
    searchgetapiCustomerPageList1() {
      console.log('searchgetapiCustomerPageList1');
      if (this.customerMerchant.length === 0) {
        this.getapiCustomerPageList('');
      }
    },
    getapiCustomerPageList(val = '') {
      apiCustomerPageList(val).then((res) => {
        if (res.code === 200) {
          this.customerMerchant = res.data;
        }
      });
    },
    searchGetUserListFocus(val) {
      if (!val) {
        this.searchFormUserList('');
      }
      if (this.formUserList.length === 0) {
        this.searchFormUserList('');
      }
      if (val) {
        const arr = val.split('~');
        getMerchantByCustomerId(arr[0]).then((res) => {
          if (res.code === 200) {
            console.log(res, 'getMerchantByCustomerId');
            this.merchantIdList = res.data;
            this.isSelect = this.merchantIdList.length > 0;
          }
        });
      } else {
        this.merchantIdList = [];
        this.isSelect = false;
      }
      this.ruleForm.merchantId = '';
    },
    searchGetUserListFocus2(val) {
      if (!val) {
        this.searchSearchUserList('');
      }
      if (this.searchUserList.length === 0) {
        this.searchSearchUserList('');
      }
      if (val) {
        getMerchantByCustomerId(val).then((res) => {
          if (res.code === 200) {
            console.log(res, 'getMerchantByCustomerId filter');
            this.customerMerchant = res.data;
          }
        });
      } else {
        this.customerMerchant = [];
      }
      this.queryForm.params.merchantId = '';
    },
    searchFormUserListFocus() {
      if (this.formUserList.length === 0) {
        this.searchFormUserList('');
      }
    },
    searchSearchUserListFocus1() {
      if (this.searchUserList.length === 0) {
        this.searchSearchUserList('');
      }
    },

    viewVersionHistory(row) {
      getVersionHistoryLocalAging({ configId: row.id }).then((res) => {
        if (res.code === 200) {
          const configTypeNameMap = {
            0: this.$t('customerManagements.ConfigTypeCustomer'),
            1: this.$t('customerManagements.ConfigTypeChannel')
          };
          const ageingTypeNameMap = {
            0: this.$t('customerManagements.CustomerDeliveryTime'),
            1: this.$t('customerManagements.CustomerClosedLoop'),
            2: this.$t('customerManagements.internalBranchTimeliness')
          };
          const obj = this.arrayToObject(this.startLabelCopy);
          const statusTypeObj = {
            1: this.$t('GlobalSetObj.enable'),
            0: this.$t('GlobalSetObj.stop')
          };
          const timeTypeObj = {
            1: this.$t('customerManagements.anTime'),
            0: this.$t('customerManagements.anDay')
          };
          this.versionHistoryData = (res.data || []).map((item) => {
            let calculatedDayList = [];
            let calculatedDayList1 = [];
            if (item.calculatedDay) {
              calculatedDayList = item.calculatedDay.split(',');
              calculatedDayList.sort();
              calculatedDayList1 = calculatedDayList.map((day) => {
                return this.weekList[day];
              });
            }
            const siteNames = Array.isArray(item.siteNames)
              ? item.siteNames.join('，')
              : item.siteNames;
            const statusTypeObjName = statusTypeObj[item.status];
            const agingTypeName = timeTypeObj[item.agingType];
            const timeframeStartingPointName = item.timeframeStartingPoint
              ? obj[item.timeframeStartingPoint]
              : '';
            return {
              ...item,
              calculatedDayList,
              calculatedDayList1,
              siteNames,
              statusTypeObjName,
              agingTypeName,
              timeframeStartingPointName,
              configTypeName: configTypeNameMap[item.configType],
              ageingTypeName: ageingTypeNameMap[item.ageingType],
              goodsTypeName: this.goodsTypeMap[item.goodsType] || this.$t('GlobalSetObj.all'),
              slaVersionDisplay: item.slaVersionDisplay || (item.slaVersion ? 'V' + Number(item.slaVersion).toFixed(1) : '- -')
            };
          });
          this.versionHistoryDialog = true;
        } else {
          this.$message.error(res.msg || '获取版本历史失败');
        }
      });
    },
    closeVersionHistoryDialog() {
      this.versionHistoryDialog = false;
      this.versionHistoryData = [];
    },
    openRefreshTaskDialog(row) {
      if (!row.slaId) {
        this.$message.warning('该配置暂无时效ID，请先编辑配置或重新上传以生成时效ID');
        return;
      }
      this.refreshForm = {
        configId: row.id,
        agingType: row.ageingType,
        slaId: row.slaId,
        slaVersion: row.slaVersion,
        customerId: row.customerId,
        customerName: row.customerName,
        channelCode: row.channelCode,
        refreshStartTime: '',
        refreshEndTime: ''
      };
      this.refreshTaskDialog = true;
    },
    closeRefreshTaskDialog() {
      this.refreshTaskDialog = false;
      if (this.$refs.refreshFormRef) {
        this.$refs.refreshFormRef.resetFields();
      }
    },
    submitRefreshTask() {
      this.$refs.refreshFormRef.validate((valid) => {
        if (valid) {
          this.refreshSubmitting = true;
          createAgingRefreshTask({
            configId: this.refreshForm.configId,
            agingType: this.refreshForm.agingType,
            slaId: this.refreshForm.slaId,
            slaVersion: this.refreshForm.slaVersion,
            customerId: this.refreshForm.customerId,
            customerName: this.refreshForm.customerName,
            channelCode: this.refreshForm.channelCode,
            refreshStartTime: this.refreshForm.refreshStartTime,
            refreshEndTime: this.refreshForm.refreshEndTime
          })
            .then((res) => {
              if (res.code === 200) {
                this.$message.success('历史数据刷新任务提交成功');
                this.refreshTaskDialog = false;
                // 跳转路由并刷新页面数据
                this.$router.push({ path: '/resource/ConfigManagement/agingHistoryRefresh' });
                this.$nextTick(() => {
                  EventBus.$emit('call-search');
                });
              } else {
                this.$message.error(res.msg || '提交任务失败');
              }
            })
            .finally(() => {
              this.refreshSubmitting = false;
            });
        }
      });
    },
    downloadVersionArea(row) {
      downloadVersionAreaLocalAging({ snapshotId: row.id }).then((res) => {
        const blobData = res.data || res;
        const blob = new Blob([blobData], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const objectUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = `历史版本明细_${row.slaVersion}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(objectUrl);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.site-names-text {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.table_class ::v-deep .el-table__cell {
  background: #fff;
}

::v-deep .el-dialog__body {
  padding: 0 15px;
  padding-bottom: 15px;
}

::v-deep {
  .drawerClass header {
    border-bottom: 1px solid #aaa !important;
    margin-bottom: 0 !important;
    padding: 20px 20px 20px !important;
  }
}

.selectLabel ::v-deep .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  border: none;
  font-weight: bold;
  text-align: left;
}

.selectLabel ::v-deep .el-input__icon {
  line-height: 28px !important;
}

.selectType ::v-deep .el-input--suffix .el-input__inner {
  border: none !important;
  font-weight: bold;
  font-size: 14px;
  text-align: left;
}

.textOperator {
  color: #00a551;
  cursor: pointer;
  font-size: 22px;
}

.textOperator1 {
  color: #f56c6c;
  cursor: pointer;
  font-size: 22px;
}

.messgeList {
  height: 450px;
  background-color: #f5f5f5;
  margin-bottom: 20px;
  border-radius: 10px;
  padding: 10px;
  overflow-y: auto;
}

.downLink {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f7fa;
  cursor: pointer;
  padding: 5px;
}

.downModule {
  color: #00a551;
  text-decoration: underline;
  cursor: pointer;
  margin-right: 15px;
}

.expressTime_class {
  width: 100%;
  margin: 20px auto;
  text-align: center;
}

.expressTime_class ::v-deep .el-button {
  margin-bottom: 20px;
}
</style>
